import { Offer } from "@/api/products";
import Flex from "@/components/Flex/Flex";
import Pill from "@/components/Pill/Pill";
import StatusBadge from "@/components/StatusBadge/StatusBadge";
import { Product } from "@/contexts/InventoryContext";
import { productConditionToString } from "../utils";
import CopyToClipBoard from "@/components/CopyToClipboard/CopyToClipboard";
import styles from "./product-details.module.css";

export default function ProductDetails(props: { product: Product, offers: Offer[] }) {
  const { product, offers } = props;

  return (
    <Flex className={styles.maxWidth} direction="column" gap={8}>
      <Flex direction="column" gap={4}>
        <img
          src={product?.image || "/images/product-placeholder.png"}
          alt="Product"
          width="432"
          height="320"
          style={{
            objectFit: "contain",
            objectPosition: "center center"
          }}
        />
        <Flex gap={2} align="center" justify="space-between">
          <Flex direction="column" gap={2} style={{minWidth: 0}} shrink={1}>
            <h3><a href={`https://www.amazon.com/dp/${product.asin}`} target="_blank">{product.name}</a></h3>
            <Flex>
              <p className="weak">Sales Rank:</p>
              &nbsp;
              <p className="strong">
                <Pill>{!product.salesRank ? "No Sales Rank" : product.salesRank.toLocaleString("en-US", { style: "decimal", maximumFractionDigits: 2 })}</Pill>
              </p> 
            </Flex>
          </Flex>
          <StatusBadge style={{flex:"0 1 max-content"}} status="danger" label="0 in stock" />
        </Flex>
      </Flex>
      <Flex direction="column" gap={4}>
        <h1>Product Details</h1>
        <Flex direction="column" gap={2}>
          <CopyToClipBoard value={product.asin} tooltipText="Copy ASIN">
            <Flex justify="space-between">
              <span>ASIN:</span>
              <p className="strong">{product.asin}</p>
            </Flex>
          </CopyToClipBoard>
          <Flex justify="space-between">
            <span>Category:</span>
            <p className="strong">{product.category}</p>
          </Flex>
          {product.sellerData?.map((data, index) => (
            <Flex key={index} justify="space-between">
              <CopyToClipBoard value={data.sku} tooltipText="Copy SKU">
                <span>SKU · Condition{product.sellerData.length > 1 ? ` (${index+1} of ${product.sellerData.length})` : ''}:</span>
                <p className="strong">{data.sku} · {productConditionToString(data.condition)}</p>
              </CopyToClipBoard>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
}
